// extracted by mini-css-extract-plugin
export default {"highlight__wrap":"Highlighting_highlight__wrap__SR4M1","highlight":"Highlighting_highlight__PnUdn"};